import sheetBatchExportModal from "@/views/menu/sheet/operation/sheetBatchExportModal.vue";

export default {
    components: {
        sheetBatchExportModal
    },
    props: {},
    data () {
        return {
            showBatchExportModal: false,

            dshRenderName: undefined
        };
    },
    computed: {
        dshRender () {
            return this[this.dshRenderName];
        }
    },
    methods: {
        clickExport () {
            this.openBatchExportModal();
        },
        /* ------ 批量导出相关 --------- */
        // 点击批量导出
        clickBatchExport () {
            this.openBatchExportModal();
        },
        // 打开批量导出模态框
        openBatchExportModal () {
            this.dshRenderName = "batchExportModalRender";
            this.showBatchExportModal = true;
        },
        // 关闭批量导出模态框
        closeBatchExportModal () {
            this.dshRenderName = undefined;
            this.showBatchExportModal = false;
        },
        // 切换批量导出模态框
        toggleBatchExportModal (bool) {
            this.showBatchExportModal = bool;
        },

        // 批量导出模态框 渲染函数
        batchExportModalRender (h, params) {
            return this.showBatchExportModal
                ? h("sheet-batch-export-modal", {
                    props: {
                        value: this.showBatchExportModal,
                        companyId: this.companyId,
                        appId: this.appId,
                        modKey: this.modKey,
                        screenKey: this.screenKey,
                        // dataIds: this.selectIds,
                        formList: this.curScreenFormList,
                        exportParams: {
                            advSearch: this.searchParams,
                            fulltextSearch: this.fulltextSearch,
                            search: {
                                conditions: this.searchConditions,
                                _id: this.selectIds.length
                                    ? {
                                        "$in": this.selectIds
                                    }
                                    : undefined
                            }
                        }
                    },
                    on: {
                        input: this.toggleBatchExportModal
                    }
                })
                : undefined;
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/sheet/operation/batchExportBtnMixin.js